import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import slbApi from "../services/slbApi";
import { Loader2 } from "lucide-react";

/**
 * SSO Start Page
 * Initiates the OIDC flow by calling the backend and redirecting to UTILIDEX
 */
export default function SSOStartPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const startSSO = async () => {
      try {
        const returnTo = searchParams.get("return_to") || "/";
        
        const response = await slbApi.get("/sso/start", {
          params: { return_to: returnTo },
        });

        if (response.data?.url) {
          // Redirect to UTILIDEX authorization URL
          window.location.href = response.data.url;
        } else {
          setError("Invalid response from SSO server");
          setLoading(false);
        }
      } catch (err) {
        console.error("SSO start failed:", err);
        // Handle different error scenarios
        let errorMessage = "Failed to start SSO";
        if (err.response?.data?.detail) {
          errorMessage = err.response.data.detail;
        } else if (err.response?.status === 520 || err.response?.status === 500) {
          errorMessage = "SSO is not configured. Please contact your administrator or use manual login.";
        } else if (err.message) {
          errorMessage = err.message;
        }
        setError(errorMessage);
        setLoading(false);
      }
    };

    startSSO();
  }, [searchParams]);

  if (loading && !error) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-orange-500 animate-spin mx-auto mb-4" />
          <h1 className="text-xl font-semibold text-white mb-2">
            Redirecting to UTILIDEX...
          </h1>
          <p className="text-zinc-400">Please wait while we connect you to sign in.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="text-center max-w-md p-6">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-red-500 text-2xl">!</span>
          </div>
          <h1 className="text-xl font-semibold text-white mb-2">
            SSO Error
          </h1>
          <p className="text-zinc-400 mb-6">{error}</p>
          <div className="flex gap-4 justify-center">
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg transition-colors"
            >
              Try Again
            </button>
            <button
              onClick={() => {
                const hostname = window.location.hostname;
                const loginPath = hostname.includes('stationlogbook.com') ? '/station-logbook/login' : '/login';
                window.location.href = loginPath;
              }}
              className="px-6 py-2 bg-zinc-700 hover:bg-zinc-600 text-white rounded-lg transition-colors"
            >
              Manual Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
